export default "__VITE_PUBLIC_ASSET__7e38a414__"